import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import { LangContext } from "../LangContext.jsx";
import FrequencyCreator from './FrequencyCreator';
import DocumentFields from './DocumentFields'; 
import DocumentFieldsCFiscal from './DocumentFieldsCFiscal';
import DocumentFieldsIMSS from './DocumentFieldsIMSS';
import DocumentFieldsInfonavit from './DocumentFieldsInfonavit';
import DocumentFieldsREPSE from './DocumentFieldsREPSE';
import DocumentFieldsSAT from './DocumentFieldsSAT';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { GENERAL_DOCUMENT_TYPE, DOC2SIGN_DOCUMENT_TYPE, CFDI_MASIVO , CFDI, CEDULA_FISCAL , SUA, PERSONA_MORAL , PERSONA_FISICA, SIMPLIFICADO_DE_CONFIANZA, REGION_FRONTERIZA, ISR, SAT, REPSE, IMSS , INFONAVIT } from '../constants';
class AutomaticDocumentForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = { 
                frequencyType:'once', 
                instructions:'',
                selectedFields: [],
                fv:'',
                selectedMimes:[1],
                is_automatic:1,
                active:true,
                documentTypes:[],
                documentType:{
                    description: [
                        "El RFC debe coincidir con el del invitado", 
                        "El sentido de la Constancia debe ser Positivo"
                    ]
                },
                type_id:5,
                mimes:[],
                frequencyKey: 0,
                autoTitleFromType: true,
                titleExists: false,
                titleChecking: false,
                titleMessage: '',
                frequencyExists: false,
                frequencyChecking: false,
                frequencyMessage: ''
        };
        this.documentFields = React.createRef();
        this.titleCheckTimeout = null;
        this.frequencyCheckTimeout = null;
    }  
    updateParentState = (updatedState) => { 
        console.log(updatedState)
        this.setState(updatedState);
    }
    async getDocumentTypes() {
        try {
            const res = await axios.get('/api/document-types/2');  
            this.setState({
                documentTypes: res.data, 
            });   
            this.setState({
                title: res.data[0].name, 
            }, () => this.debouncedCheckTitle(res.data[0].name));  
        } catch (error) {
            console.error('Error fetching document types:', error);
        }
    }
    componentWillUnmount() {
        if (this.titleCheckTimeout) {
            clearTimeout(this.titleCheckTimeout);
        }
        if (this.frequencyCheckTimeout) {
            clearTimeout(this.frequencyCheckTimeout);
        }
    }

    async componentDidMount() {
        const { lang } = this.context; 
        await this.getMimes()
        await this.getDocumentTypes()
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                extensions: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.necesitas_especificar_los_formatos_del_documento_antes_de_guardarlo')
                        },
                    }
                },
                title: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.nombre_requerido')
                        },
                        stringLength: {
                            min: 3,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_3')
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });
        this.setState({fv: fv});
        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    this.save();
                }
            })
            let fields = [];
            fields = this.documentFields.current.state.fields
        })
    }

    componentDidUpdate(prevProps, prevState) {
        const keys = ['type_id', 'frequencyType', 'every', 'repeatOn', 'ends', 'cicles', 'dayOfWeek', 'monthFrequencyType', 'ReferDay', 'day', 'dayOfMonth', 'monthOfYear'];
        const changed = keys.some((key) => prevState[key] !== this.state[key]);
        if (changed) {
            this.debouncedCheckFrequency();
        }
    }

    save() {
        if (this.state.titleExists || this.state.titleChecking || this.state.frequencyExists || this.state.frequencyChecking) {
            return;
        }

        window.blockUI();
        let fields = [];
        let all_fields = [];  
        fields = this.documentFields.current.state.fields
        all_fields = this.documentFields.current.state.all_fields 
        fields.forEach((el) => { el.required = false; });
        
        const emptyTitleFields = fields.filter((el) => el.title.trim() === ''); 
        const fieldsWithValidation = fields.filter((el) => el.hasValidation == true);
        let emptyFields = false; 
        const fieldsWithEmptyConditions = fieldsWithValidation.filter((el) => {
            if (el.conditions) {
                el.conditions.map(con =>{
                    if(con.param1 != 6 && con.param1 != 7 && con.param1 != 8){
                        if(con.param2 === '' || con.param2 === null || con.param2 === undefined ){
                            emptyFields = true
                        }
                    } 
                })
            }
            return el.conditions === undefined || el.conditions.length === 0;
        });  
        if(emptyFields == true){
            swal.fire({
                text: `Contienes condiciones sin valores, favor de revisar`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }
        if(fieldsWithEmptyConditions.length > 0){
            swal.fire({
                text: `Todas las validaciones automaticas deben contener al menos una condición`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }
        if (emptyTitleFields.length > 0) {
            const emptyFieldIds = emptyTitleFields.map((el) => el.type);
            swal.fire({
                text: `Por favor, completa los títulos de los campos adicionales de tipo: ${emptyFieldIds.join(', ')}`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }  
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        }
        const params = JSON.stringify({
            every: this.state.every,
            repeat_on: this.state.repeatOn,
            ends: this.state.ends,
            cicles: this.state.cicles,
            day_of_week: this.state.dayOfWeek,
            month_frequency_type: this.state.monthFrequencyType,
            refer_day: this.state.ReferDay,
            day: this.state.day,
            day_of_month: this.state.dayOfMonth,
            month_of_year: this.state.monthOfYear,
            instructions:this.state.instructions,
            title: this.state.title,
            frequency: this.state.frequencyType,
            size: parseInt(this.props.max_upload_size || 10, 10),
            mimes:[1],
            is_automatic: this.state.is_automatic,
            cfdi_id: this.state.cfdi,
            api_method: this.state.api_method, 
            required: true,
            active: this.state.active,
            fields: fields,
            all_fields: all_fields,
            period: this.state.period,
            type_id:  this.state.type_id,
            displayCfdiInput:this.state.displayCfdiInput,
            template:this.state.template,
            deleteTemplate: this.state.deleteTemplate,
            dateValidationComponentId:this.state.dateValidationComponentId, 
        }) 
        this.create(params)
    } 
    async create(params) {   
        const { lang } = this.context; 
        var form = document.getElementById("frm");
        var formData = new FormData(form);
        await axios.post(
            '/api/documents', params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            if($('#template').val() != ''){
                let documentId = response.data.id;
                axios.post('/api/documents/template/'+documentId,formData).then(res=>{
                })
            }
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: lang.get('messages.guardado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/documents';
            });
        }).catch((error) => {
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            const message = getErrorsMessage(error); 
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    async getMimes() {
        const res = await axios.get('/api/mimes')
        const filteredMimes = res.data.filter(mime => mime.id !== 5); 
        this.setState({ mimes: filteredMimes }); 
    }
    handleMimeChanged = (e) => {
        const v = parseInt(e.target.value);
        if (e.target.checked) {
            this.setState(prevState => ({
                selectedMimes: [...prevState.selectedMimes, v],
            }) )
        } else {
            const selectedMimes = [...this.state.selectedMimes];
            const index = selectedMimes.indexOf(v);
            if (index > -1) {
                selectedMimes.splice(index, 1);
                this.setState({ selectedMimes: selectedMimes } );
            }
        }
    }
    handleInstructionsChange = (e) =>{
        this.setState({
            instructions: e.target.value
        });
    }


    handleTitleChange = (e) => {
        const title = e.target.value;
        this.setState({
            title,
            autoTitleFromType: false
        });
        this.debouncedCheckTitle(title);
    }

    debouncedCheckTitle = (title) => {
        if (this.titleCheckTimeout) {
            clearTimeout(this.titleCheckTimeout);
        }

        const normalizedTitle = (title || '').trim();
        if (normalizedTitle.length < 3) {
            this.setState({
                titleExists: false,
                titleChecking: false,
                titleMessage: ''
            });
            return;
        }

        this.setState({ titleChecking: true });
        this.titleCheckTimeout = setTimeout(() => {
            this.checkTitleAvailability(normalizedTitle);
        }, 450);
    }

    checkTitleAvailability = async (title) => {
        try {
            const response = await axios.post('/api/documents/check-title', { title });
            const exists = response?.data?.exists === true;
            this.setState({
                titleExists: exists,
                titleChecking: false,
                titleMessage: exists ? (response?.data?.message || 'Ya existe una plantilla con este nombre.') : ''
            });
        } catch (error) {
            this.setState({
                titleChecking: false,
                titleExists: false,
                titleMessage: ''
            });
        }
    }

    debouncedCheckFrequency = () => {
        if (this.frequencyCheckTimeout) {
            clearTimeout(this.frequencyCheckTimeout);
        }

        const isGeneral = (this.state.type_id === 1 || this.state.type_id === '1');
        const requiresValidation = this.state.frequencyType === 'yearly' || this.state.frequencyType === 'once';

        if (isGeneral || !requiresValidation) {
            this.setState({
                frequencyExists: false,
                frequencyChecking: false,
                frequencyMessage: ''
            });
            return;
        }

        this.setState({ frequencyChecking: true });
        this.frequencyCheckTimeout = setTimeout(() => {
            this.checkFrequencyAvailability();
        }, 450);
    }

    checkFrequencyAvailability = async () => {
        try {
            const payload = {
                type_id: this.state.type_id,
                frequency: this.state.frequencyType,
                every: this.state.every,
                repeat_on: this.state.repeatOn,
                ends: this.state.ends,
                cicles: this.state.cicles,
                day_of_week: this.state.dayOfWeek,
                month_frequency_type: this.state.monthFrequencyType,
                refer_day: this.state.ReferDay,
                day: this.state.day,
                day_of_month: this.state.dayOfMonth,
                month_of_year: this.state.monthOfYear,
            };

            const response = await axios.post('/api/documents/check-frequency', payload);
            const exists = response?.data?.exists === true;
            this.setState({
                frequencyExists: exists,
                frequencyChecking: false,
                frequencyMessage: exists ? (response?.data?.message || 'Ya tienes una frecuencia repetida para este tipo de plantilla.') : ''
            });
        } catch (error) {
            this.setState({
                frequencyExists: false,
                frequencyChecking: false,
                frequencyMessage: ''
            });
        }
    }

    documentTypesChange = (e)=>{  
        const selectedId = e.target.value;
        const selectedDocument = this.state.documentTypes.find(doc => doc.id.toString() === selectedId);
        
        this.setState(prevState => ({
            type_id: e.target.value,
            title: (prevState.autoTitleFromType || !prevState.title) ? selectedDocument.name : prevState.title,
            documentType: selectedDocument,
            frequencyKey: prevState.frequencyKey + 1
        }), () => this.debouncedCheckTitle(this.state.title));
    }

    render() {
        const { lang } = this.context; 
        return (
            <form id="frm" encType="multipart/form-data">
            <div className="card card-custom gutter-b">
                <div className="card-body flex-grow-1">
                    <div className="row mt-6">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <p className="font-weight-bold">{lang.get('messages.seleccione_la_plantilla_mensual')}</p>
                                <select id="document_system_id" value={this.state.type_id} className="form-control form-control-solid bg-white" onChange={this.documentTypesChange}>
                                    <option>-- {lang.get('messages.seleccionar')} --</option>
                                    {this.state.documentTypes.map((d, i) => {
                                        return <option key={i} value={d.id}>{d.name}</option>;
                                    })}
                                </select>
                            </div>

                            <div className="form-group">
                                <p className="font-weight-bold">Nombre de plantilla</p>
                                <input
                                    type="text"
                                    name="title"
                                    className="form-control form-control-solid bg-white"
                                    value={this.state.title || ''}
                                    onChange={this.handleTitleChange}
                                    placeholder="Ej. Constancia Fiscal Proveedores"
                                />
                                {this.state.titleExists && (
                                    <small className="text-danger d-block mt-1">{this.state.titleMessage}</small>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-3 justify-content-center text-left"> 
                                <div className="col-sm-11 form-group">  
                                    <FrequencyCreator 
    key={this.state.frequencyKey}
    updateParentState={this.updateParentState} 
    category={this.props.category} 
    documentType={this.state.type_id} 
/> 
                                    {this.state.frequencyExists && (
                                        <small className="text-danger d-block mt-1">{this.state.frequencyMessage}</small>
                                    )}
                                </div>
                        </div>
                        <div className="col-sm-3"  > 
                            <div> 
                                <label className="text-left">{lang.get('messages.'+this.props.upload_document_template)}</label>
                                <input id="template" className="form-control "  type="file" name="template"/>
                            </div>
                        </div>
                        <div className="col-sm-6 text-left mt-6">
                                <label className="text-left">{lang.get('messages.formatos')}</label>
                                <div className="checkbox-inline form-group">
                                    {this.state.mimes.map(({id, title}) => {
                                        return(
                                            <label  key={id}  className="checkbox checkbox-lg checkbox-square checkbox-disabled">
                                                <input  type="checkbox"  name="extensions"  disabled={true}
                                                value={id}   checked={this.state.selectedMimes.includes(id)}  onChange={this.handleMimeChanged}   />
                                                <span></span>
                                                {title}
                                            </label>
                                        )
                                    })}
                                </div> 
                            </div>
                    </div>
                    <div className="d-flex">
                        <div className="flex-grow-1"> 
                            <div className="text-left mt-6"> 
                                <strong className="mt-6 d-block">{lang.get('messages.maximo_10_mb_por_archivo')}</strong>
                                <div className="form-group mt-8">
                                    <label className="text-left">{lang.get('messages.instrucciones_de_llenado_de_plantilla')}</label>
                                    <textarea className="form-control" value={this.state.instructions} name="instructions" onChange={this.handleInstructionsChange }></textarea>
                                </div>
                            </div>
                        </div> 
                    </div> 
                    {this.state.type_id == CEDULA_FISCAL &&   <DocumentFieldsCFiscal ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/> }
                    {this.state.type_id == INFONAVIT &&   <DocumentFieldsInfonavit ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/> }
                    {this.state.type_id == SAT &&   <DocumentFieldsSAT ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/> }
                    {this.state.type_id == REPSE &&   <DocumentFieldsREPSE ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/> }
                    {this.state.type_id == IMSS &&   <DocumentFieldsIMSS ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/> }
 
                    {(this.state.type_id == SUA || this.state.type_id == PERSONA_MORAL 
                    || this.state.type_id == PERSONA_FISICA  || this.state.type_id == SIMPLIFICADO_DE_CONFIANZA  
                    || this.state.type_id == REGION_FRONTERIZA || this.state.type_id == ISR ) 
                    &&   <DocumentFields ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/> }
                
                    <div className="  card mt-6 p-9"> 
                    <strong className="mb-3">Información a validar para el documento</strong>
                        <div className="card mt-3 p-9 bg-light-light">
                            {this.state.documentType.description.map((item,index) => {
                                return (
                                    <div key={index} className="mb-2 d-flex align-items-start">
                                        <span className="mr-2">
                                            <i className="fa fa-check icon text-primary font-size-xs"></i>
                                        </span>
                                        <span style={{ flex: 1 }}>
                                            {item}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div> 
                </div>
                
                <div className="text-right gap-1 mr-10 mb-10">
                    <a href="/documents" className="btn btn-lg btn-secondary">
                        {lang.get('messages.cancelar')}
                    </a>
                    <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4" disabled={this.state.titleExists || this.state.titleChecking || this.state.frequencyExists || this.state.frequencyChecking}>
                        {lang.get('messages.guardar')}
                    </button>
                </div> 
            </div>
            </form>
        )
    }
}

export default AutomaticDocumentForm;

if (document.getElementById('AutomaticDocumentForm')) {
    ReactDOM.render(<AutomaticDocumentForm />, document.getElementById('AutomaticDocumentForm'));
}
